export default "__VITE_PUBLIC_ASSET__4019fb05__"